<template>
  <el-form ref="formData" inline :model="form" :rules="rules">
    <el-form-item label="时间范围" prop="time">
      <el-date-picker
        v-model="dateRange"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        style="max-width: 600px;"
      >
      </el-date-picker>
    </el-form-item>
    <el-form-item label="设备号" prop="driveNo">
      <el-select
        v-model="form.driveNo"
        placeholder="设备号"
        filterable
        clearable
        :disabled="!!driveNo"
        @change="onDriveChange"
        style="max-width:200px"
      >
        <el-option
          v-for="item in driveData"
          :key="item.driveNo"
          :label="item.driveNo"
          :value="item.driveNo"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-button type="primary" @click="query">查询</el-button>
    <el-button @click="reset">重置</el-button>
  </el-form>
</template>
<script>
import dayjs from '@/libs/util.date'
import validate from '@/libs/util.validate'

export default {
  props: {
    dispatchOrderNo: String,
    driveNo: String,
  },
  data() {
    const pickerFormat = (picker, beforeDays, baseDays) => {
      const now = baseDays || dayjs()
      let before = now
      if (beforeDays) {
        before = before.subtract(beforeDays, 'days')
      }
      picker.$emit('pick', [before.startOf('date'), now.endOf('date')])
    }
    return {
      rules: {
        driveNo: [{ required: true, message: '请选择设备' }],
      },
      // 所有设备的数据
      driveData: [],
      // 当前选中的设备
      selectedDrive: {},
      form: { ...this.getInitForm() },
      dateRange: [dayjs().startOf('days'), dayjs().endOf('days')],
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick: (picker) => pickerFormat(picker),
          },
          {
            text: '昨天',
            onClick: (picker) =>
              pickerFormat(picker, 0, dayjs().subtract(1, 'days')),
          },
          {
            text: '最近两天',
            onClick: (picker) => pickerFormat(picker, 1),
          },
          {
            text: '最近7天',
            onClick: (picker) => pickerFormat(picker, 6),
          },
          {
            text: '最近10天',
            onClick: (picker) => pickerFormat(picker, 9),
          },
        ],
      },
    }
  },
  computed: {
    driveDateMap() {
      const driveData = this.driveData || []
      return Object.fromEntries(driveData.map((item) => [item.driveNo, item]))
    },
  },
  watch: {
    dateRange: {
      handler(val) {
        if (val) {
          const [startTime, endTime] = val
          this.form.startTime = dayjs(startTime).format('YYYY-MM-DD HH:mm:ss')
          this.form.endTime = dayjs(endTime).format('YYYY-MM-DD HH:mm:ss')
        } else {
          this.form.startTime = ''
          this.form.endTime = ''
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.loadDriveSelect()

    // 如果传入的设备号非空 立即执行一次查询
    if (this.driveNo) {
      this.query()
    }
  },
  methods: {
    // 初始表单
    getInitForm() {
      return {
        driveNo: this.driveNo,
      }
    },
    // 初始表单
    getForm() {
      return {
        ...this.form,
      }
    },
    onDriveChange(val) {
      this.selectedDrive = this.driveDateMap[val]
    },
    loadDriveSelect() {
      this.$api
        .waybillDriveListByDispatchOrderNoApi(this.dispatchOrderNo)
        .then((res) => {
          this.driveData = res.body.data

          if (this.driveNo) {
            this.onDriveChange(this.driveNo)
            this.$emit('driveChange', this.selectedDrive)
          }
        })
    },
    // 初始查询
    async query({ isReset = true } = {}) {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return

      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('driveChange', this.selectedDrive)
      this.$emit('query', this.form)
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...this.getInitForm() }
    },
  },
}
</script>
